import { render, staticRenderFns } from "./UpmsOrganization.vue?vue&type=template&id=a00bbb9e&"
import script from "./UpmsOrganization.vue?vue&type=script&lang=js&"
export * from "./UpmsOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports